import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Text, Button } from '@gasbuddy/react-components';
import styles from './styles.css';

class BannerMessage extends React.Component {
  static propTypes = {
    message: PropTypes.string,
    headerText: PropTypes.string,
    secondaryText: PropTypes.string,
    mode: PropTypes.oneOf(['simple', 'detailed']),
    onClickButton: PropTypes.func,
    upperCase: PropTypes.bool,
  };

  static defaultProps = {
    message: '',
    headerText: '',
    secondaryText: '',
    mode: 'simple',
    onClickButton: () => { throw new Error('onClickButton handler is missing'); },
    upperCase: false,
  };

  renderButtonOrText = () => {
    const { message, mode, onClickButton, headerText, secondaryText, upperCase } = this.props;

    switch (mode) {
      case 'simple':
        return (
          <Text bold centered>
            {upperCase ? message.toUpperCase() : message}
          </Text>
        );
      case 'detailed':
        return (
          <div className={styles.innerPanel}>
            <div className={styles.messageText}>
              <div className={styles.headerText}>{headerText}</div>
              <div className={styles.secondaryHeaderText}>{secondaryText}</div>
            </div>
            { message && (
              <Button
                className="float-right"
                color="white"
                size="sm"
                rounded
                onClick={onClickButton}
              >
                {message}
              </Button>
            ) }
            <div className="clearfix" />
          </div>
        );
      default:
        return `THE MODE "${mode}" IS NOT SUPPORTED`;
    }
  }

  render() {
    return (
      <Panel className={styles.updatePanel}>
        {this.renderButtonOrText()}
      </Panel>
    );
  }
}

export default BannerMessage;
